/* 
Quick Tip 

- Use the below function in the EmojiGame Component to shuffle the emojisList every time when an emoji is clicked.

const shuffledEmojisList = () => {
  const {emojisList} = this.props
  return emojisList.sort(() => Math.random() - 0.5)
}

*/

// Write your code here.
import {Component} from 'react'
// import {v4 as uuidv4} from 'uuid'
import NavBar from '../NavBar'
import EmojiCard from '../EmojiCard'
import WinOrLoseCard from '../WinOrLoseCard'
import './index.css'

class EmojiGame extends Component {
  state = {
    score: 0,
    topScore: 0,
    gamePlay: true,
    selectedemoji: [],
    // emojisList: [],
  }

  shuffledEmojisList = () => {
    const {emojisList} = this.props
    return emojisList.sort(() => Math.random() - 0.5)
  }

  /* toStop = isFound => {
    if (isFound === true) {
      return 0
    }
    return 1
  }
  toPlay = isFound => {
    if (isFound === true) {
      return false
    }
    return true
  }
  toTopScore = (isFound, topScore, score) => {
    if (isFound !== true) {
      return score + 1 > topScore ? score + 1 : topScore
    }
    return topScore
  } */
  finisGame = length => {
    const {topScore} = this.state
    if (length > topScore) {
      this.setState({score: length, gamePlay: false})
    }
  }

  emojiSelect = id => {
    const {selectedemoji} = this.state
    const {emojisList} = this.props
    const isFound = selectedemoji.includes(id)
    const {length} = selectedemoji
    if (isFound) {
      this.finisGame(length)
    } else {
      if (emojisList.length - 1 === length) {
        this.finisGame(emojisList.length)
      }
      this.setState(prevState => ({
        selectedemoji: [...prevState.selectedemoji, id],
        score: prevState.selectedemoji.length + 1,
      }))
    }
    /* this.setState(prevState => ({
      score: prevState.score + this.toStop(isFound),
      // emojisList: [...this.shuffledEmojisList()],
      gamePlay: this.toPlay(isFound),
      topScore: this.toTopScore(isFound, prevState.toTopScore, prevState.score),
      selectedemoji: [...prevState.selectedemoji, id],
    })) */
  }

  toSetTopScore = (topScore, score) => {
    if (score > topScore) {
      return score
    }
    return topScore
  }

  toPlayAgain = () => {
    const {score, topScore} = this.state
    this.setState(prevState => ({
      score: 0,
      selectedemoji: [],
      gamePlay: true,
      topScore: this.toSetTopScore(score, topScore),
    }))
  }

  render() {
    const {score, topScore, gamePlay} = this.state
    const emojisList = this.shuffledEmojisList()
    return (
      <div className="game_container">
        {<NavBar gamePlay={gamePlay} topScore={topScore} score={score} />}
        {gamePlay === true ? (
          <ul className="emojis_container">
            {emojisList.map(every => (
              <EmojiCard
                key={every.id}
                emoji={every}
                emojiSelect={this.emojiSelect}
              />
            ))}
          </ul>
        ) : (
          <WinOrLoseCard
            toPlayAgain={this.toPlayAgain}
            score={score}
            topScore={topScore}
          />
        )}
      </div>
    )
  }
}
export default EmojiGame
